export default __webpack_public_path__ + "static/media/screen8.83801da9.jpg";